<template>
  <div class="star-rating">
    <div class="stars-container">
      <span
        v-for="star in 5"
        :key="star"
        class="star"
        :class="{
          'filled': star <= filledStars,
          'animated': animate
        }"
        :style="{ animationDelay: `${star * 0.1}s` }"
      >
        <span v-if="star <= filledStars" class="star-filled" :style="{ color: color }">★</span>
        <span v-else class="star-empty">☆</span>
      </span>
    </div>
    <span v-if="showCount" class="star-count">{{ filledStars }}/5</span>
  </div>
</template>

<script>
export default {
  name: 'StarRating',
  props: {
    stars: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 5
    },
    showCount: {
      type: Boolean,
      default: true
    },
    animate: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#FF9800'
    }
  },
  computed: {
    filledStars() {
      return Math.floor(this.stars);
    }
  }
};
</script>

<style scoped>
.star-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.stars-container {
  display: flex;
  gap: 0.25rem;
}

.star {
  font-size: 1.25rem;
  line-height: 1;
  transition: transform 0.2s ease;
}

.star.animated {
  animation: starPop 0.5s ease-out forwards;
}

.star-filled {
  /* Color is set dynamically via inline style */
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.3));
}

.star-empty {
  color: #D1D5DB;
  font-size: 1.5rem;
}

.star-count {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6B7280;
}

@keyframes starPop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
